import { useTokenStore, useUserStore } from '@/plugins/stores';
import { useI18n } from 'vue-i18n';
import { onMounted } from 'vue';
import ServiceResponse from '@/models/ServiceResponse';
import ServiceController from '@/controllers/ServiceController';
import { AuthResponseStatus } from '@/enums/AuthResponseStatus';
import AuthenticationHelper from '@/util/AuthenticationHelper';
import Response from '@/models/Response';

export default {
  name: 'SelectServiceForm',
  setup() {
    const userStore = useUserStore();
    const i18n = useI18n();
    onMounted(async () => {
      const tokenStore = useTokenStore();
      const serviceResponse: Response = await ServiceController.getServices(tokenStore.accessToken);
      if (serviceResponse.status === AuthResponseStatus.SUCCESS) {
        const userStore = useUserStore();
        userStore.services = (serviceResponse as ServiceResponse).services;
        AuthenticationHelper.setTokens(serviceResponse);
      }
    });
    return {
      userStore,
      i18n
    };
  }
};
